import messages from '@/vendor/da_messages';
import { defineRule } from 'vee-validate';
import moment from 'moment';
import { localize, setLocale } from '@vee-validate/i18n';
import { configure } from 'vee-validate';
import validateLicensePlate from '@/validators/LicensePlateExists';
import {
    digits,
    email,
    integer,
    is_not,
    is,
    max,
    max_value,
    min,
    min_value,
    numeric,
    regex,
    required,
    alpha_num
  } from '@vee-validate/rules';

defineRule('digits', digits);
defineRule('email', email);
defineRule('integer', integer);
defineRule('is_not', is_not);
defineRule('is', is);
defineRule('max', max);
defineRule('max_value', max_value);
defineRule('min', min);
defineRule('min_value', min_value);
defineRule('numeric', numeric);
defineRule('regex', regex);
defineRule('required', required);
defineRule('alpha_num', alpha_num);
defineRule('valid_date_range', (value:any, args:any) => { return moment(value).isBetween(args[0], args[1], null, '[]'); });

defineRule('custom_required', (value: any, _, field: any) => {
  if (value === false) return (messages['custom_required'] as any)(field);

  if (value === undefined || value === null || value === '-1' || value === -1 || value === '')
    return (messages['custom_required'] as any)(field);

  return true;
});
defineRule('required_notnull', (v: any, _, field: any) => {
  if (v === null || v === undefined) return (messages['required'] as any)(field);
  return true;
});
defineRule(
  'validate_postalcode',
  // Custom validation message
  //getMessage: () => 'Postnummer er ikke gyldigt',
  // Custom validation rule
  async (value: string) => {
    const response = await $.get('//dawa.aws.dk/postnumre?q=' + value);
    if (Object.keys(response).length) return true;
    return 'Postnummer er ikke gyldigt';
  }
);

defineRule('is-future-date', (value: string) => {
  if (!value || !moment(value).isValid()) {
    return 'Invalid date';
  }

  const selectedDateAndTime = moment(value);
  const currentDateAndTime = moment();

  return (
    selectedDateAndTime.isSameOrBefore(currentDateAndTime) ||
    'Du kan ikke vælge et tidspunkt efter ' + currentDateAndTime.format('HH:mm')
  );
});

defineRule('min_date', (value: any, args: any) => {
  const selectedDate = moment(value, (window as any).dateFormat);
  const minDate = moment(args, (window as any).dateFormat);
  return selectedDate.isSameOrAfter(minDate);
});

defineRule('max_date', (value: any, args: any) => {
  const selectedDate = moment(value, (window as any).dateFormat);
  const maxDate = moment(args, (window as any).dateFormat);
  return selectedDate.isSameOrBefore(maxDate);
});

defineRule('license_plate_exists', validateLicensePlate);

defineRule('decimal', (value: string, [places = 2, separator = ',']) => {
  const regex = new RegExp(`^\\d+${separator}[0-9]{0,${places}}$`);
  return regex.test(value) || false;
});

defineRule('letters_numbers', (value: string) => {
  const letterNumber = /^[0-9a-zA-ZæøåÆØÅ-]+$/;
  return letterNumber.test(value);
});

setLocale('da');

configure({
  generateMessage: localize('da', {
    messages
  }),
  validateOnInput: true
});